module.exports = __webpack_public_path__ + "files/web-developer-4.078dbb10.pdf";